"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jspdf_1 = require("jspdf");
const jspdf_autotable_1 = __importDefault(require("jspdf-autotable"));
const moment_1 = __importDefault(require("moment"));
const dayjs_1 = __importDefault(require("../../shared/lib/dayjs"));
const currency_1 = require("../../shared/utils/currency");
const generateTableRowsFromScheduledPayments_1 = __importDefault(require("./generateTableRowsFromScheduledPayments"));
function generateAmortizationTableInPdf(bbva, powerTrain, enganche, plazo, hasInsurance) {
    const fontStyle = "";
    const docPdf = new jspdf_1.jsPDF({
        format: "letter",
    });
    let pageWidth = docPdf.internal.pageSize.getWidth();
    const montoDelPrestamo = bbva.requestedAmount.amount ?? 0;
    const comisionDeApertura = bbva.fees.itemizeFees[0].feeAmount.amount ?? 0;
    const pagoMensual = bbva.installmentPlan.installmentAmount.amount ?? 0;
    const seguroDeAuto = bbva.additionalProducts[0].amount ?? 0;
    const tasaDeInteres = bbva.rates[0].unit.percentage ?? 0;
    const seguroDeVida = bbva.additionalProducts[1].amount ?? 0;
    const cat = bbva.rates[1].unit.percentage ?? 0;
    const montoTotalAPagar = bbva.totalAmount.amount ?? 0;
    const tableRows = (0, generateTableRowsFromScheduledPayments_1.default)(bbva);
    docPdf.text("Tabla de Amortización BBVA Consumer Finance", pageWidth / 2, 20, { align: "center" });
    docPdf.text("FECHA DE EMISIÓN: " + (0, moment_1.default)().format("DD/MM/YYYY"), pageWidth / 2, 30, {
        align: "center",
    });
    docPdf.text(powerTrain.name + " " + powerTrain?.trim?.model?.year, pageWidth / 2, 40, { align: "center" });
    docPdf.setFontSize(13);
    docPdf.text("Monto del Préstamo: " + (0, currency_1.parseToMexicanPeso)(montoDelPrestamo), 20, 60);
    docPdf.text("Enganche: " + (0, currency_1.parseToMexicanPeso)(enganche), 120, 60);
    docPdf.line(15, 65, 200, 65, "F");
    docPdf.text("Plazo: " + plazo, 20, 75);
    docPdf.text("Comisión de Apertura (4): " + (0, currency_1.parseToMexicanPeso)(comisionDeApertura), 120, 75);
    docPdf.text("Pago Mensual (1): " + (0, currency_1.parseToMexicanPeso)(pagoMensual), 20, 85);
    docPdf.text("Seguro de Auto: " + (0, currency_1.parseToMexicanPeso)(seguroDeAuto), 120, 85);
    docPdf.text("Tasa de Interés (2): " + tasaDeInteres + "%", 20, 95);
    docPdf.text("Seguro de Vida: " + (0, currency_1.parseToMexicanPeso)(seguroDeVida), 120, 95);
    docPdf.text("CAT (3): " + cat + "%", 20, 105);
    docPdf.text("Monto Total a Pagar: " + (0, currency_1.parseToMexicanPeso)(montoTotalAPagar), 120, 105);
    docPdf.setFontSize(12);
    docPdf.text("1 Pago mensual sin IVA.", 20, 125);
    docPdf.text("2", 20, 130);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text("Tasa Fija de Interés Anual.", 24, 130);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`3`, 20, 135);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text(`CAT ${cat}%`, 24, 135);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`"Sin IVA" informativo.`, 48, 135);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text(`Fecha de cálculo: `, 90, 135);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`${(0, dayjs_1.default)().format("DD/MM/YYYY")}.`, 127, 135);
    docPdf.setFont(fontStyle, "bold");
    docPdf.text(`Vigencia de la oferta: `, 20, 140);
    docPdf.setFont(fontStyle, "normal");
    docPdf.text(`${(0, dayjs_1.default)().format("DD/MM/YYYY")}.`, 64, 140);
    docPdf.text("4 Comisión por apertura 0.00% sobre el monto a financiar (pago único al inicio).", 20, 145);
    docPdf.text("Aplican Restricciones.", 20, 150);
    docPdf.text("Las cantidades presentadas en esta tabla se encuentran en pesos méxicanos.", 20, 155);
    if (hasInsurance) {
        docPdf.text("La Tabla de Amortización no considera el seguro de daños, este deberá cotizarse y", 20, 165);
        docPdf.text("dependiendo de la forma de pago, podrá modificar los datos aquí asentados.", 20, 170);
    }
    docPdf.text("Este documento es para efectos informativos y no constituye obligación y ofrecimiento", 20, 175);
    docPdf.text("formal por parte de BBVA Bancomer, S.A. en el otorgamiento del Crédito.", 20, 180);
    docPdf.text("Las condiciones de los Créditos estarán sujetas a cambios sin previo aviso.", 20, 185);
    (0, jspdf_autotable_1.default)(docPdf, {
        head: [
            [
                "Núm. Periodo",
                "Saldo Insoluto Auto",
                "Prima Seguro Daños con IVA",
                "Prima Seguro Vida con IVA",
                "Pago Mensual Capital Auto",
                "Pago Mensual Intereses Auto",
                "IVA Intereses Auto",
                "Pago Total con IVA",
            ],
        ],
        startY: 200,
        body: tableRows,
    });
    return docPdf;
}
exports.default = generateAmortizationTableInPdf;
